var caseStudyTabComponent = (function () {
    var csComponentTabs = document.querySelectorAll('.cs-tabs-panel__list-item[role="tab"]'),
        csContentPanel = document.querySelectorAll('.cs-tabs-content__main[role="tabpanel"]');

    return {
      init: init,
    };

    function init() {
        if (csComponentTabs.length && csContentPanel.length) {
            //Add min-height for all tab desc section
            var tabContentSection = document.querySelectorAll('.cs-tabs-content__child-left-main'),
                tabSectionMaxHeight = [],
                tabCardMaxHeight = [];
            for (var j = 0; j < tabContentSection.length; j++) {
                tabSectionMaxHeight.push(tabContentSection[j].offsetHeight);
                tabCardMaxHeight.push(tabContentSection[j].closest('.cs-tabs-content__child').querySelector('.cs-tabs-content__card-wrap').offsetHeight);
                if (j > 0) {
                    tabContentSection[j].closest("[data-href-target]").classList.add('hide');
                    tabContentSection[j].closest("[data-href-target]").classList.remove('cs-tabs-content__temp');
                }
            }
            for (var k = 0; k < tabContentSection.length; k++) {
                tabContentSection[k].style.minHeight = Math.max.apply(Math, tabSectionMaxHeight) + 'px'; // set max height
                tabContentSection[k].closest('.cs-tabs-content__child').querySelector('.cs-tabs-content__card-wrap').style.minHeight = Math.max.apply(Math, tabCardMaxHeight) + 'px'; // set max height
            }

            // For easy reference
            var keys = {
                end: 35,
                home: 36,
                left: 37,
                up: 38,
                right: 39,
                down: 40,
                delete: 46,
                enter: 13,
                space: 32,
            };

            // Add or subtract depending on key pressed
            var direction = {
                37: -1,
                38: -1,
                39: 1,
                40: 1,
            };

            // Bind listeners for product component
            for (i = 0; i < csComponentTabs.length; ++i) {
                setEventsOnCsComponentTabs(i);
            }

            function setEventsOnCsComponentTabs(index) {
                csComponentTabs[index].addEventListener('click', setClickEvtOnCsComponentTab);
                csComponentTabs[index].addEventListener('keydown', setKeydownEvtOnCsComponentTab);
                csComponentTabs[index].addEventListener('keyup', setKeyupEvtOnCsComponentTab);

                // Build an array with all tabs (<button>s) in it
                csComponentTabs[index].index = index;
            }

            // When a tab is clicked, activateTab is fired to activate it
            function setClickEvtOnCsComponentTab(event) {
                var tab = event.target;
                activateCsComponentTab(tab, false);
            }

            // Handle keydown on Product tabs
            function setKeydownEvtOnCsComponentTab(event) {
                var key = event.keyCode;

                switch (key) {
                    case keys.end:
                        event.preventDefault();
                        // Activate last tab
                        focusCsComponentLastTab();
                        break;
                    case keys.home:
                        event.preventDefault();
                        // Activate first tab
                        focusCsComponentFirstTab();
                        break;
                    default:
                }
            }

            // Handle keyup on Product tabs
            function setKeyupEvtOnCsComponentTab(event) {
                var key = event.keyCode;

                switch (key) {
                    case keys.left:
                    case keys.right:
                        switchCsTabOnArrowPress(event);
                        break;
                    case keys.enter:
                    case keys.space:
                        activateCsComponentTab(event.target);
                        break;
                    default:
                }
            }

            // Either focus the next, previous, first, or last tab
            // depending on key pressed
            function switchCsTabOnArrowPress(event) {
                var pressed = event.keyCode;
                if (direction[pressed]) {
                    var target = event.target;
                    if (target.index !== undefined) {
                        if (csComponentTabs[target.index + direction[pressed]]) {
                            csComponentTabs[target.index + direction[pressed]].focus();
                        } else if (pressed === keys.left || pressed === keys.up) {
                            focusCsComponentLastTab();
                        } else if (pressed === keys.right || pressed == keys.down) {
                            focusCsComponentFirstTab();
                        }
                    }
                }
            }

            // Activates any given tab panel
            function activateCsComponentTab(tab, setFocus) {
            
                setFocus = setFocus || true;                   
            
                // Deactivate all other tabs
                deactivateCsComponentTabs();

                // Remove tabindex attribute
                tab.removeAttribute('tabindex');

                // Set the tab as selected
                tab.setAttribute('aria-selected', 'true');

                //set active to parent element
                tab.parentElement.classList.add('cs-tabs-panel__list--active');

                // Get the value of aria-controls (which is an ID)
                var panelControl = tab.getAttribute('aria-controls'),
                    panelControlDom = document.getElementById(panelControl);  // Remove hidden attribute from product panel to make it visible

                if (panelControlDom) {
                    panelControlDom.setAttribute('aria-hidden', 'false');
                    panelControlDom.parentElement.classList.remove('hide');
                }

                // Set focus when required
                if (setFocus) {
                    tab.focus();
                }
                
                //show images from lazy load
                lazyLoading.show();
            }

            // Deactivate all tabs and tab panels
            function deactivateCsComponentTabs() {
                for (var j = 0; j < csComponentTabs.length; j++) {
                    csComponentTabs[j].setAttribute('tabindex', '-1');
                    csComponentTabs[j].setAttribute('aria-selected', 'false');
                    csComponentTabs[j].parentElement.classList.remove('cs-tabs-panel__list--active');
                }

                for (var k = 0; k < csContentPanel.length; k++) {
                    csContentPanel[k].setAttribute('aria-hidden', 'true');
                    csContentPanel[k].parentElement.classList.add('hide');
                }
            }

            // Make a guess
            function focusCsComponentFirstTab() {
                csComponentTabs[0].focus();
            }

            // Make a guess
            function focusCsComponentLastTab() {
                csComponentTabs[csComponentTabs.length - 1].focus();
            }
        }
    }
})();

//caseStudyTabComponent.init();